import { Range } from 'slate';
import { getListItemsInRange } from "./getListItemsInRange.js";
import { isListItemContainingText } from "./isListItemContainingText.js";
/**
 * Returns true when editor has collapsed selection and the cursor is in an empty "list-item".
 */

export function isCursorInEmptyListItem(editor) {
  if (!editor.selection || Range.isExpanded(editor.selection)) {
    return false;
  }

  var listItemsInSelection = getListItemsInRange(editor, editor.selection);

  if (listItemsInSelection.length !== 1) {
    return false;
  }

  var [[listItemNode]] = listItemsInSelection;
  return !isListItemContainingText(editor, listItemNode);
}